<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,11.999999940395355C10,11.999999940395355,13,11.999999940395355,13,11.999999940395355C13.55,11.999999940395355,14,11.549999940395356,14,10.999999940395355C14,10.999999940395355,14,6.999999940395355,14,6.999999940395355C14,6.449999940395355,13.55,5.999999940395355,13,5.999999940395355C13,5.999999940395355,10,5.999999940395355,10,5.999999940395355C9.45,5.999999940395355,9,6.449999940395355,9,6.999999940395355C9,6.999999940395355,9,10.999999940395355,9,10.999999940395355C9,11.549999940395356,9.45,11.999999940395355,10,11.999999940395355C10,11.999999940395355,10,11.999999940395355,10,11.999999940395355ZM15,13.999999940395355C15,13.999999940395355,1,13.999999940395355,1,13.999999940395355C0.45,13.999999940395355,0,14.449999940395355,0,14.999999940395355C0,15.549999940395356,0.45,15.999999940395355,1,15.999999940395355C1,15.999999940395355,15,15.999999940395355,15,15.999999940395355C15.55,15.999999940395355,16,15.549999940395356,16,14.999999940395355C16,14.449999940395355,15.55,13.999999940395355,15,13.999999940395355C15,13.999999940395355,15,13.999999940395355,15,13.999999940395355ZM3,11.999999940395355C3,11.999999940395355,6,11.999999940395355,6,11.999999940395355C6.55,11.999999940395355,7,11.549999940395356,7,10.999999940395355C7,10.999999940395355,7,1.9999999403953552,7,1.9999999403953552C7,1.4499999403953552,6.55,0.9999999403953552,6,0.9999999403953552C6,0.9999999403953552,3,0.9999999403953552,3,0.9999999403953552C2.45,0.9999999403953552,2,1.4499999403953552,2,1.9999999403953552C2,1.9999999403953552,2,10.999999940395355,2,10.999999940395355C2,11.549999940395356,2.45,11.999999940395355,3,11.999999940395355C3,11.999999940395355,3,11.999999940395355,3,11.999999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentBottom',
} as DefineComponent
</script>
